import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Flex, Heading, Link, Button } from '@liquidcollectibles/uikit'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import useTheme from 'hooks/useTheme'
import tokens from 'config/constants/tokens'
import { getAddress } from 'utils/addressHelpers'
import { SlideSvgDark, SlideSvgLight } from './SlideSvg'

const flyingAnim = () => keyframes`
  from {
    transform: translate(0,  0px);
  }
  50% {
    transform: translate(-10px,-30px);
  }
  to {
    transform: translate(0, 0px);
  }  
`

const Container = styled.div`
  width: 100%;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: flex;
    min-height: 100vh;
  }
`

const BgWrapper = styled.div`
  z-index: -1;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100% - 0px);
  /* height: 100px; */
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: gray; */
`

const InnerWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: -4px;
`

const BunnyWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  /* max-height: 400px; */
  /* background-color: gray; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* animation: ${flyingAnim} 3.5s ease-in-out infinite; */
  img {
    max-height: 600px;
    opacity: 0.8;
    /* width: 25vw; */
  }
`

const ActionButton = styled(Button)`
  height: 32px;
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.sm} {
    height: 40px;
    font-size: 16px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    height: 48px;
    font-size: 20px;
  }
`

const WalletButton = styled(ConnectWalletButton)`
  height: 32px;
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.sm} {
    height: 40px;
    font-size: 16px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    height: 48px;
    font-size: 20px;
  }
`

const Title = styled(Heading)`
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0.18px;
  margin-bottom: 8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 48px;
    line-height: 72px;
    letter-spacing: -0.5px;
    margin-bottom: 24px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 60px;
  }
`

const Subtitle = styled(Heading)`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-bottom: 32px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 40px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 20px;
  }
`

const imagePath = '/images/home/'
const imageSrc = 'animatedlimos'

const HeroSection = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { theme } = useTheme()

  return (
    <Container>
      <BgWrapper>
        <InnerWrapper>{theme.isDark ? <SlideSvgDark width="100%" /> : <SlideSvgLight width="100%" />}</InnerWrapper>
      </BgWrapper>
      <Flex position="relative" flexDirection={[null, null, null, 'row']} alignItems={[null, null, null, 'center']}>
        <Flex flex="1" flexDirection="column" style={{ zIndex: 2, justifyContent: 'center' }}>
          <Title scale="xxl" color="white">
            {t('Simple safe NFT liquidity maker.')}
          </Title>
          <Subtitle scale="md">{t('Create token indexes that are backed by NFTs.')}</Subtitle>
          <Flex>
            {!account && <WalletButton mr="8px" />}
            <Link external href={`https://dex.apeswap.finance/swap?outputCurrency=${getAddress(tokens.lico.address)}`}>
              <ActionButton mr="8px" variant="secondary">
                {t('Buy LICO')}
              </ActionButton>
            </Link>
          </Flex>
        </Flex>

        <Flex
          height={[null, null, null, '100%']}
          width={['105px', null, '192px', '100%']}
          flex={[null, null, null, '1']}
          mb={[null, null, null, '0']}
          position="relative"
        >
          <BunnyWrapper>
            <img src={`${imagePath}${imageSrc}.png`} alt={t('Lunar bunny')} />
          </BunnyWrapper>
        </Flex>
      </Flex>
    </Container>
  )
}

export default HeroSection
